export default "__VITE_ASSET__DKRpX7OA__"